import { enableProdMode, APP_INITIALIZER, importProvidersFrom } from '@angular/core';

import { serviceLoader, createTranslateLoader } from '../src/app/app.module';
import { environment } from '../src/environments/environment';

import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { AppComponent } from '../src/app/app.component';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { provideAnimations } from '@angular/platform-browser/animations';
import { Drivers } from '@ionic/storage';
import { IonicStorageModule } from '@ionic/storage-angular';
import { Capacitor } from '@capacitor/core';
import { provideAuth, initializeAuth, indexedDBLocalPersistence, getAuth } from '@angular/fire/auth';
import { provideFirebaseApp, initializeApp, getApp } from '@angular/fire/app';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { AppRoutingModule } from '../src/app/app-routing.module';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { EmailComposer } from '@awesome-cordova-plugins/email-composer/ngx';
import { TuneInfoService } from '../src/app/services/audio/tune-info.service';
import { AudioService } from '../src/app/services/audio/audio.service';
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient, HttpClient } from '@angular/common/http';
import { AppLoaderService } from '../src/app/services/app-loader.service';
import { StoreService } from '../src/app/services/store/store.service';
import { LibraryService } from 'src/app/services/library.service';
import { RouteReuseStrategy } from '@angular/router';
import { AudioDownloadService } from '../src/app/services/audio/audio-download.service';
import { StorageService } from '../src/app/services/storage/storage.service';
import { LoginService } from '../src/app/services/auth/login.service';
import { CachingService } from '../src/app/services/caching/caching.service';
import { ConnectivityService } from '../src/app/services/connectivity/connectivity.service';
import { NativeStorage } from '@awesome-cordova-plugins/native-storage/ngx';
import { DatePipe } from '@angular/common';

import 'hammerjs';
import { AuthInterceptor, LibConfig, LibConfigService } from 'bandon-shared';
import { QuillModule, QuillModules } from 'ngx-quill';
import { provideIonicAngular, IonicRouteStrategy } from '@ionic/angular/standalone';

const libConfig: LibConfig = {
  apiServerUrl: environment.apiURL,
  apiKey: environment.apiKey,
  navigateToLogin: true,
  loginUrl: '/collection/user/login'
};


const quillModules: QuillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'], // toggled buttons
    ['blockquote'],

//    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: 'ordered' }, { list: 'bullet' }],

    [{ header: [1, 2, 3, 4, 5, 6, false]}],

//    [{ color: [] }, { background: [] }],
  ]
}

bootstrapApplication(AppComponent, {
    providers: [
      provideFirebaseApp(() => initializeApp(environment.firebase)),
      provideAuth(() => {
        if (Capacitor.isNativePlatform()) {
            return initializeAuth(getApp(), {
                persistence: indexedDBLocalPersistence
            });
        }
        else {
            return getAuth();
        }
      }),
      provideIonicAngular({
        backButtonText: ''
      }),
      importProvidersFrom(
          BrowserModule,
          QuillModule.forRoot({
            modules: quillModules
          }),
          AppRoutingModule,
          TranslateModule.forRoot({
            defaultLanguage: 'en',
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
          }),
          IonicStorageModule.forRoot({
            driverOrder: [Drivers.IndexedDB]
          }),
          YouTubePlayerModule
        ),
        NativeStorage,
        ConnectivityService,
        CachingService,
        LoginService,
        StorageService,
        AudioDownloadService,
        {
            provide: RouteReuseStrategy,
            useClass: IonicRouteStrategy
        },
        LibraryService,
        StoreService,
        {
            provide: APP_INITIALIZER,
            useFactory: serviceLoader,
            deps: [AppLoaderService],
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        AudioService,
        TuneInfoService,
        EmailComposer,
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        DatePipe,
        { provide: 'LIB_CONFIG', useValue: libConfig },
        { provide: LibConfigService, useClass: LibConfigService, deps: ['LIB_CONFIG'] },
      ]
})
  .catch(err => console.log(err));

defineCustomElements(window);
if (environment.production) {
  enableProdMode();
}
